import React, { useState, useEffect } from 'react';
import { PUBLIC_IMG_URL } from '/src/lib/endpoints';



const featuresList = [
    {
        title: 'Identify High-Growth VC backed companies',
        description: 'Discover the fastest-scaling, venture-backed companies in the Emerging Venture Markets. Curate your search by sector, stage, geography, and investor to identify qualified opportunities faster',
        image: 'feature-screen-startups.webp'
    },
    {
        title: 'Find Active LPs & Capital Sources',
        description: 'Raising a fund? Identify the region\'s most active LPs, family offices, and institutional investors. Track mandates, activity, and historical allocations.',
        image: 'feature-screen-industry.webp'
    },
    {
        title: 'Benchmark Markets in Real Time',
        description: 'Prepare board or client presentations using live, dynamic venture market data. Visualize market sizing, compare sectors, and export charts and datasets directly from the platform.',
        image: 'feature-screen-industrybenchmarking.webp'
    },
    {
        title: 'Analyze Fund Performance',
        description: 'Evaluate fund performance, investments, and exits of regional funds. Compare peer sets benchmarking investor track records over time.',
        image: 'feature-screen-funds.webp'
    }
];

const Features = () => {

    /*
     * the animation begins when the element is scrolled into view,
     * it ends when element is scrolled out of view
    **/

    // set which section to display based on current animation step
    const [currentIndex, setCurrentIndex] = useState(0);
    const [shouldAnimate, setShouldAnimate] = useState(false);

    // check if section is scrolled into view, before starting animation
    const checkSectionInView = (entries) => {
        const [entry] = entries;
        setShouldAnimate(entry.isIntersecting);
    };

    /* use IntersectionObserver to check when element is scrolled into / scrolled out of */
    useEffect(() => {
        const observer = new IntersectionObserver(checkSectionInView);
        const target = document.querySelector('.section-features-wrapper');

        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) {
                observer.unobserve(target);
            }
        };
    }, []);

    // set animation (steps loop)
    useEffect(() => {

        let interval;

        if (shouldAnimate) {
            interval = setInterval(() => {
                setCurrentIndex(prevIndex => {
                    let maxSteps = featuresList.length;
                    let tmpIndex = (prevIndex + 1) % maxSteps; // use modulo to wrap index around when it reaches max
                    return tmpIndex;
                });
            }, 4000); // 4 sec
        } else {
            clearInterval(interval);
            setCurrentIndex(0);
        }

        // clear interval on component unmount
        return () => clearInterval(interval);

    }, [shouldAnimate]);

    return (
        <div className="section-features-wrapper">
            <div className="page-header">
                <h2>Built to integrate into your Private Market Infrastructure Strategy</h2>
            </div>
            <div className="section-features">
                <div>
                    {featuresList.map((item, i) => {
                        if (i === 0 || i === 1) {
                            return (
                                <div className="feature-box" data-animation={shouldAnimate && currentIndex === i} key={`feature-${i}`}>
                                    <h6>{item.title}</h6>
                                    <p>{item.description}</p>
                                </div>
                            )
                        }
                    })}
                </div>
                <div className="feature-image"><img src={`${PUBLIC_IMG_URL}/pricing/feature-screenshot/${featuresList[currentIndex].image}`} className="img-fluid" /></div>
                <div>
                    {featuresList.map((item, i) => {
                        if (i > 1) {
                            return (
                                <div className="feature-box" data-animation={shouldAnimate && currentIndex === i} key={`feature-${i}`}>
                                    <h6>{item.title}</h6>
                                    <p>{item.description}</p>
                                </div>
                            )
                        }
                    })}
                </div>
            </div>
        </div>
    )
}

export default Features;
